var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeExpert" }, [
          _c("div", { staticClass: "home-expert marginAuto max1720" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass:
                  "swiper-container banner2 home-expert-rol positionRE"
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.$store.state.home.getDotor, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "swiper-slide positionRE" },
                      [
                        _c("div", { staticClass: "displayIB" }, [
                          _c("img", {
                            staticClass: "home-expert-doctorimg",
                            attrs: { src: _vm.httptype(item.img), alt: "" }
                          })
                        ]),
                        _c(
                          "div",
                          { staticClass: "home-expert-doctorText displayIB" },
                          [
                            _c("p", { staticClass: "font36px" }, [
                              _vm._v(_vm._s(item.name) + " "),
                              _c("span", {
                                staticClass: "displayIB home-expert-hr"
                              })
                            ]),
                            _c(
                              "p",
                              {
                                staticClass: "col666666 home-expert-doctorTlt"
                              },
                              [_vm._v(_vm._s(item.education))]
                            ),
                            _c(
                              "p",
                              { staticClass: "home-expert-doctor-intro" },
                              [_vm._v(_vm._s(item.content))]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "swiper-container banner5 expert-all-doctorlist displayIB positionRE"
                },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.$store.state.home.getDotor, function(
                      item,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "expert-doctorlist swiper-slide pointEr",
                          on: {
                            mousemove: function($event) {
                              return _vm.moveChange(index, "true")
                            },
                            mouseleave: function($event) {
                              return _vm.moveChange(index, "false")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "displayIB" }, [
                            _c("img", {
                              staticClass: "expert-doctorlist-img",
                              attrs: {
                                src: _vm.httptype(item.img),
                                alt: "",
                                title: ""
                              }
                            })
                          ]),
                          _vm.activeIndex === index ||
                          _vm.activeIndex2 === index
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "expert-doctorlist-name positionAB colffffff"
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  ),
                  _c("div", { staticClass: "min-next pointEr positionAB" }),
                  _c("div", { staticClass: "min-prev pointEr positionAB" })
                ]
              )
            ])
          ])
        ])
      : _c("div", { staticClass: "phone-page" }, [
          _vm._m(1),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "swiper-container bannerEx home-team-bar home-rol"
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.$store.state.home.getDotor, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "swiper-slide" },
                      [
                        _c("div", { staticClass: "PhoneExpert-Box" }, [
                          _c("img", {
                            staticClass: "PhoneExpert-img",
                            attrs: {
                              src: _vm.httptype(item.img),
                              alt: "3大保障·脂玫乐健康瘦身值得您托付",
                              title: ""
                            }
                          }),
                          _c("div", { staticClass: "PhoneExpert-TextBox" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "PhoneExpert-Name col33333 font40phone"
                              },
                              [
                                _vm._v(
                                  "\n                  " + _vm._s(item.name)
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "PhoneExpert-Tip font36phone"
                                  },
                                  [_vm._v(_vm._s(" - " + item.education))]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "PhoneExpert-introduce" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.content) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "p",
        {
          staticClass: "part-title list-tlt displayIB",
          staticStyle: { width: "100%" }
        },
        [
          _vm._v("\n          脂玫乐健康瘦身专家团\n          "),
          _c("span", { staticClass: "list-tlt-tip" }, [_vm._v("-")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "PhoneHome-title" }, [
      _vm._v("\n      脂玫乐健康瘦身专家团 "),
      _c("span", { staticClass: "col00CDA2" }, [_vm._v("-")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34728403", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34728403","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/comPonents/homeExpert/homeExpert.vue
// module id = 985
// module chunks = 1